import { SunIcon, BriefcaseIcon, CheckBadgeIcon, NoSymbolIcon } from '@heroicons/react/24/outline';
import type { PaidRestFilterKey } from '../../models/vacationPaidRest.types';
import type { PaidRestCardMetadata, PaidRestFilterGroup } from './vacationPaidRestFilterSidebar.types';
export {
    CARD_TONE_CLASSES,
    CARD_ICON_WRAP_CLASSES,
    CARD_LABEL_CLASSES,
    CARD_VALUE_CLASSES,
    CARD_ACTIVE_CLASSES,
    CARD_FOCUS_CLASSES,
} from '../shared/filterCardTones';

export const PAID_REST_CARD_METADATA: Record<PaidRestFilterKey, PaidRestCardMetadata> = {
    inRest: {
        label: 'Em descanso',
        tone: 'success',
        description: 'PJs em descanso remunerado hoje',
        icon: SunIcon,
    },
    offRest: {
        label: 'Fora de descanso',
        tone: 'neutral',
        description: 'PJs sem descanso remunerado em curso hoje',
        icon: BriefcaseIcon,
    },
    withRight: {
        label: 'Com direito',
        tone: 'info',
        description: 'PJs com direito a descanso remunerado no contrato',
        icon: CheckBadgeIcon,
    },
    withoutRight: {
        label: 'Sem direito',
        tone: 'neutral',
        description: 'PJs sem direito a descanso remunerado no contrato',
        icon: NoSymbolIcon,
    },
};

export const PAID_REST_FILTER_GROUPS: readonly PaidRestFilterGroup[] = [
    {
        id: 'situation',
        label: 'SITUAÇÃO',
        keys: ['inRest', 'offRest'],
    },
    {
        id: 'right',
        label: 'DIREITO',
        keys: ['withRight', 'withoutRight'],
    },
];

export const PARTITION_HINT =
    'Marcar os dois cartões de um grupo equivale a não filtrar por ele — cada PJ conta em um dos dois.';
